
<template>
  <v-content class="pt-3">
    <v-container>
      <v-layout justify-center row wrap>
        <v-flex xs12 sm8 md6 lg5>
          <v-card style="border-radius:12px">
            <v-img class="white--text" height="180px" :src="loginBG">
              <v-card-title
                class="align-end fill-height headline"
                v-if="false"
              >{{$t('login_title')}}</v-card-title>
            </v-img>
            <v-card-text>
              <v-form ref="login" lazy-validation v-model="valid">
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  prepend-icon="mdi-account-circle"
                  :label="`${this.$t('login_label')}`"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :rules="[rules.required]"
                  prepend-icon="mdi-eye-off"
                  :label="`${this.$t('password_label')}`"
                  type="password"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-layout column justify-center align-center>
                <v-btn
                  type="submit"
                  round
                  color="primary"
                  :loading="loading"
                  @click="handleSubmit()"
                  :disabled="this.$auth.check()"
                >
                  <v-icon left>fa-sign-in-alt</v-icon>
                  {{$t('login_button')}}
                </v-btn>
                <span v-if="false" class="mt-4 grey--text">ou entrar com</span>
                <v-layout row wrap justify-center v-if="false">
                  <v-btn text icon color="red" @click="/*do_method()*/">
                    <v-icon>mdi-google</v-icon>
                  </v-btn>
                  <v-btn text icon color="blue" @click="/*do_method()*/">
                    <v-icon>mdi-facebook</v-icon>
                  </v-btn>
                </v-layout>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions } from "vuex";
import LoginBG from "../../../public/img/background/login.jpeg";

export default {
  data: () => ({
    loginBG: LoginBG,
    email: null, //"teste3@teste.com",
    password: null, // "teste123",
    drawer: null,

    valid: true,
    loading: false,
    rules: {
      required: v => !!v || "Campo é necessário",
      email: v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail deve ser válido",
      cpf: v => (v && v.length == 11) || "CPF deve ser completo"
    }
  }),

  props: {
    source: String
  },

  methods: {
    handleSubmit: function(e) {
      this.loading = true;
      this.valid = true;
      if (this.$refs.login.validate()) {
        this.$auth.login({
          params: { email: this.email, password: this.password },
          success(res) {
            this.$auth.user(res.data.data);
            this.showThisUser(this.$auth.user());
            this.$swal({
              toast: true,
              position: "top-end",
              timer: 3000,
              showConfirmButton: false,
              title: "Seja bem vindo " + this.$auth.user().email,
              type: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#003a3e"
            });
            // alert( "Seja bem vindo "+ this.$auth.user().email)
          },
          error(res) {
            this.loading = false;
            this.$swal({
              toast: true,
              position: "top-end",
              timer: 2000,
              showConfirmButton: false,
              title: "Acesso negado...",
              type: "error",
              confirmButtonText: "OK",
              confirmButtonColor: "#003a3e"
            });
            console.log("error " + res.data);
            this.error = res.data;
          }
        });
      } else {
        this.loading = false;
      }
    },
    ...mapActions({
      showThisUser: "Users/setUser"
    })
    // handleGoogleLogin: function (e) {
    //   this.$auth

    // },
  }
};
</script>